<template>
  <b-card header-tag="header">
    <template slot="header">
      <h3>Latest Jobs</h3>
      <router-link tag="a" to="/jobs" exact>
        View All Jobs
        <font-awesome-icon icon="angle-right" size="lg" fixedWidth class="icon"/>
      </router-link>
    </template>
    <div class="jobs-swimlanes">
      <b-row>
        <b-col>
          <h4 class="status-registered">
            Registered
            <span
              class="badge badge-pill badge-registered float-right"
            >{{ registeredJobs.length }}</span>
          </h4>
          <JobCard
            v-for="job in registeredJobs"
            :key="job.labRegistrationReference"
            :labRef="job.labRegistrationReference"
            :jobId="job.jobId"
            :description="job.registrationDescription"
            :clientRef="job.clientRegistrationReference"
            :status="job.status"
            :priority="job.priority"
            :purchaseOrder="job.purchaseOrder"
            :sampleCount="job.numberOfSamples"
            :receivedDate="job.receivedDate"
            :dueDate="job.finalisedDateTime"
          />
        </b-col>
        <b-col>
          <h4 class="status-results-available">
            Results Available
            <span
              class="badge badge-pill badge-results-available float-right"
            >{{ finalisedJobs.length }}</span>
          </h4>
          <JobCard
            v-for="job in finalisedJobs"
            :key="job.labRegistrationReference"
            :labRef="job.labRegistrationReference"
            :jobId="job.jobId"
            :description="job.registrationDescription"
            :clientRef="job.clientRegistrationReference"
            :status="job.status"
            :priority="job.priority"
            :purchaseOrder="job.purchaseOrder"
            :sampleCount="job.numberOfSamples"
            :receivedDate="job.receivedDate"
            :dueDate="job.finalisedDateTime"
          />
        </b-col>
        <b-col>
          <h4 class="status-complete">
            Complete
            <span
              class="badge badge-pill badge-complete float-right"
            >{{ completedJobs.length }}</span>
          </h4>
          <JobCard
            v-for="job in completedJobs"
            :key="job.labRegistrationReference"
            :labRef="job.labRegistrationReference"
            :jobId="job.jobId"
            :description="job.registrationDescription"
            :clientRef="job.clientRegistrationReference"
            :status="job.status"
            :priority="job.priority"
            :purchaseOrder="job.purchaseOrder"
            :sampleCount="job.numberOfSamples"
            :receivedDate="job.receivedDate"
            :dueDate="job.finalisedDateTime"
          />
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<style lang="scss">
@import "../assets/styles/main.scss";
.jobs-swimlanes {
  h4 {
    text-transform: uppercase;
    font-weight: $font-weight-regular;
    font-size: 1rem;
    margin-bottom: 15px;
    &.status-registered {
      color: $status-processing;
    }
    &.status-complete {
      color: $status-completed;
    }
    &.status-results-available {
      color: $status-finalised;
    }
  }
}
</style>

<script>
import { EventBus } from "@/services/event-bus.js";
import JobCard from "@/components/JobCard.vue";
import { searchJobs } from "@/services/api";

export default {
  name: "LatestJobs",
  components: { JobCard },
  props: {
    selectedClients: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      registeredJobs: [],
      completedJobs: [],
      finalisedJobs: [],
      loading: false
    };
  },
  mounted() {
    this.refreshAll();
  },
  watch: {
    selectedClients: function() {
      this.refreshAll();
    },
    loading: function() {
      if (this.loading) {
        EventBus.$emit("showLoader");
      } else {
        EventBus.$emit("hideLoader");
      }
    }
  },
  methods: {
    async refreshAll() {
      //if(/^\/?$/.test(this.$root._route.fullPath)) {
      this.loading = true;
      await Promise.all([
        this.fetchRegisteredJobs(),
        this.fetchCompletedJobs(),
        this.fetchFinalisedJobs()
      ]);
      this.loading = false;
      //}
    },
    async fetchRegisteredJobs() {
      const params = {
        page: 1,
        pageSize: 20,
        orderFields: [
          {
            field: "modifiedDateTime",
            direction: "DESC"
          }
        ],
        searchFields: {
          status: "Registered"
        }
      };

      // client selection
      if (this.selectedClients.length > 0) {
        params.searchFields.clients = this.selectedClients.map(
          client => client.id
        );
      }

      const result = await searchJobs(params);
      this.registeredJobs = result.jobs;
    },
    async fetchCompletedJobs() {
      const params = {
        page: 1,
        pageSize: 20,
        orderFields: [
          {
            field: "modifiedDateTime",
            direction: "DESC"
          }
        ],
        searchFields: {
          status: "Complete"
        }
      };

      // client selection
      if (this.selectedClients.length > 0) {
        params.searchFields.clients = this.selectedClients.map(
          client => client.id
        );
      }

      const result = await searchJobs(params);
      this.completedJobs = result.jobs;
    },
    async fetchFinalisedJobs() {
      const params = {
        page: 1,
        pageSize: 20,
        orderFields: [
          {
            field: "modifiedDateTime",
            direction: "DESC"
          }
        ],
        searchFields: {
          status: "Results Available"
        }
      };

      // client selection
      if (this.selectedClients.length > 0) {
        params.searchFields.clients = this.selectedClients.map(
          client => client.id
        );
      }

      const result = await searchJobs(params);
      this.finalisedJobs = result.jobs;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/LatestJobs.vue